import { AuthTo } from '@common/Auth'
import ImgGallery from '@common/ImgGallery'
import { PRODUCT_MICRO_WEBSITE, REALNAME_AUTH_PATH } from '@constant'
import { HeaderView } from '@merchant-backend/common-components'
import { isHotelProperty, isOnlineShop } from '@merchant-backend/util'
import { hasAuthByProductId, isHotelMerchant, isNewHotel } from '@util'
import { Button, Input, message, Radio } from 'hljd'
import { toJS } from 'mobx'
import { observer } from 'mobx-react'
import QRCode from 'qrcode.react'
import React, { Component } from 'react'
import CopyToClipboard from 'react-copy-to-clipboard'
import { Link } from 'react-router'
import Store from './store'
import styles from './style.module.less'

const RadioGroup = Radio.Group

const items = [
  {
    id: 3,
    title: '公告',
    name: 'can_show_announcement'
  },
  {
    id: 4,
    title: '到店礼',
    name: 'can_show_gift'
  },
  {
    id: 5,
    title: '店铺推荐',
    name: 'can_show_recommend'
  },
  {
    id: 6,
    title: '动态',
    name: 'can_show_feed'
  }
]

const hotelItems = [
  {
    id: 3,
    title: '特色信息',
    name: 'can_show_feature'
  },
  {
    id: 4,
    title: '专享优惠',
    name: 'can_show_exclusive_offer'
  },
  {
    id: 5,
    title: '订阅消息',
    name: 'can_show_subscribe_news'
  }
]

@AuthTo({
  isAuthed: () => hasAuthByProductId(PRODUCT_MICRO_WEBSITE),
  link: '/localMerchant/weiShopSetting/intro'
})
@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.store = new Store()
  }

  componentDidMount() {
    this.store.getInfoData()
  }

  getItems = () => {
    if (isHotelMerchant()) {
      return hotelItems
    }

    return items
  }

  showRealnameAuth = is_no_name => {
    if (isOnlineShop()) {
      return false
    }
    if (isHotelProperty()) {
      return isNewHotel() && is_no_name
    }

    return is_no_name
  }

  render() {
    const {
      merchant_info,
      title,
      photos = [],
      qrcodeShow,
      isWeiShopSet
    } = this.store
    const store = this.store

    let is_no_name =
      (merchant_info.certify?.status != 3 && merchant_info.is_new == 1) ||
      (merchant_info.is_opened_trade == false && merchant_info.is_new == 0)

    let hostname = window.location.hostname
    let httpHostName
    let httpHostNameLink
    switch (hostname) {
      case 'www.hunliji.com':
        httpHostName = `https://h5.hunliji.com/weidian/${
          merchant_info.id
        }?preview=1`
        httpHostNameLink = `https://h5.hunliji.com/weidian/${merchant_info.id}`
        break
      case 'www7.hunliji.com':
        httpHostName = `http://h57.hunliji.com/weidian/${
          merchant_info.id
        }?preview=1`
        httpHostNameLink = `http://h57.hunliji.com/weidian/${merchant_info.id}`
        break
      default:
        httpHostName = `http://dev.hunliji.com/p/wedding/Public/wap/m/merchant.html?id=${
          merchant_info.id
        }&is_weidian=1&preview=1`
        httpHostNameLink = `http://dev.hunliji.com/p/wedding/Public/wap/m/merchant.html?id=${
          merchant_info.id
        }&is_weidian=1`
        break
    }

    return (
      <HeaderView title="微官网">
        <p className={styles.titleName}>模块设置</p>

        {this.showRealnameAuth(is_no_name) && (
          <div
            style={{
              padding: '160px 0 230px 0',
              textAlign: 'center',
              background: '#fff'
            }}
          >
            <img
              style={{ display: 'inline-block', marginBottom: 15 }}
              src="http://qnm.hunliji.com/o_1bfqpsma2m5627q1nia1kedhn37.png"
            />
            <div>
              <p style={{ fontSize: 16, color: '#666', lineHeight: '26px' }}>
                完成实名认证，客户才能看见您的店铺。
              </p>
              <Link to={REALNAME_AUTH_PATH}>
                <Button type="primary" style={{ marginTop: 26 }}>
                  去认证
                </Button>
              </Link>
            </div>
          </div>
        )}

        <div className={styles.wrap}>
          <div className={styles.imgBox}>
            <div className={styles.outer}>
              <div className={styles.inner}>
                <div className={styles.img}>
                  <img
                    src={
                      isHotelMerchant()
                        ? '//qnm.hunliji.com/o_1cb64kfv913rg3r1gv9fvcpugc.jpg'
                        : '//qnm.hunliji.com/o_1bi5o8ehg1dnbmqr10gj10cjdkl7.png'
                    }
                  />
                </div>
              </div>
              <img
                className={styles.fixedImg}
                src={
                  isHotelMerchant()
                    ? 'http://qnm.hunliji.com/o_1cb9oi5d7u8vfq21vb9obm1ct2c.png'
                    : 'http://qnm.hunliji.com/o_1bi7qlkaq311r831ivn1pjueat7.jpg'
                }
              />
            </div>
            <p>支持鼠标上下滚动预览</p>
          </div>
          <div className={styles.box}>
            <p className={styles.titleTip}>
              你可以自由设置店铺名称和轮播图，其余模块将自动同步你在婚礼纪平台上的设置，你可设置模块显示/隐藏
            </p>

            <div className={styles.item}>
              <span className={styles.circle}>1</span>
              <span className={styles.name}>店铺名称</span>
              <Input
                name="title"
                value={title}
                style={{ width: 300 }}
                onChange={e => {
                  const val = {
                    target: {
                      value: e.target.value,
                      name: 'title'
                    }
                  }
                  store.onChange(val)
                }}
              />
              {/*<span style={{paddingLeft:10}}>0/20</span>*/}
            </div>
            <div className={styles.item}>
              <span className={styles.circle}>2</span>
              <span className={styles.name}>轮播图</span>
              <span className={styles.pictureTip}>
                推荐尺寸640*300，最多上传三张，支持jpg、png格式，10M之内
              </span>
              <div style={{ marginLeft: 122 }}>
                <ImgGallery
                  max={3}
                  keyField="img"
                  style={{ marginTop: 10 }}
                  multiple={true}
                  showUpload={photos.length < 4}
                  onRemove={store.removePhotos}
                  onOk={store.AddPhotos}
                  imgList={toJS(photos)}
                />
              </div>
            </div>

            {this.getItems().map(({ id, title, name }) => {
              return (
                <div className={styles.item} key={id}>
                  <span className={styles.circle}>{id}</span>
                  <span className={styles.name}>{title}</span>
                  <RadioGroup
                    name={name}
                    value={store[name]}
                    onChange={store.onChange}
                  >
                    <Radio value={1}>显示</Radio>
                    <Radio value={0}>隐藏</Radio>
                  </RadioGroup>
                </div>
              )
            })}

            <div className={styles.btn}>
              <Button
                style={{ marginRight: 12 }}
                onClick={store.postInfoDataValue('1')}
              >
                预览
              </Button>
              <Button onClick={store.postInfoDataValue('0')} type="primary">
                保存设置
              </Button>
            </div>
          </div>
        </div>

        {qrcodeShow && (
          <div className={styles.qrcodeMask} onClick={store.Qrcode}>
            <div className={styles.qrcodeBox}>
              <div className={styles.qrcode}>
                <QRCode value={httpHostName} size={220} />
              </div>
              <p>扫码预览</p>
            </div>
          </div>
        )}

        {isWeiShopSet ? (
          <>
            <p className={styles.titleName}>配置链接</p>
            <div className={styles.wrapLink}>
              <p>你可以复制相关页面链接，在微信公众号后台进行菜单配置</p>
              <p className={styles.storeAddress}>
                <span className={styles.name}>首页</span>
                <span className={styles.link}>{httpHostNameLink}</span>
                <CopyToClipboard
                  onCopy={() => message.success('已复制到剪切板！')}
                  text={httpHostNameLink}
                >
                  <Button type="primary">复制</Button>
                </CopyToClipboard>
              </p>
              <p className={styles.storeAddress}>
                <span className={styles.name}>门店地址</span>
                <span className={styles.link} style={{ width: 690 }}>
                  https://apis.map.qq.com/tools/poimarker?type=0&marker=coord:{
                    merchant_info.latitude
                  },{merchant_info.longitude};coordtype:3;title:{
                    merchant_info.name
                  };addr:{merchant_info.address}&key=GMZBZ-ZCD3U-GY3VD-4PJK3-BRTK3-SQFWZ&referer=hunliji
                </span>
                <CopyToClipboard
                  onCopy={() => message.success('已复制到剪切板！')}
                  text={`https://apis.map.qq.com/tools/poimarker?type=0&marker=coord:${
                    merchant_info.latitude
                  },${merchant_info.longitude};coordtype:3;title:${
                    merchant_info.name
                  };addr:${
                    merchant_info.address
                  }&key=GMZBZ-ZCD3U-GY3VD-4PJK3-BRTK3-SQFWZ&referer=hunliji`}
                >
                  <Button type="primary">复制</Button>
                </CopyToClipboard>
              </p>
            </div>
          </>
        ) : (
          <div
            style={{
              marginTop: 20,
              fontSize: 16,
              fontWeight: 'bold'
            }}
          >
            配置链接将在首次保存设置后自动生成
          </div>
        )}
      </HeaderView>
    )
  }
}
